import * as z from "zod";
import { TestCaseStepperContent } from "./TestCaseStepperContent";
import { TranslatedText } from "./TranslatedText";
export const Stepper = z.object({
    type: z.literal("stepper"),
    value: z.object({
        title: TranslatedText,
        contents: TestCaseStepperContent.array(),
    }),
});
